import script from "./terms-condition.vue?vue&type=script&setup=true&lang=ts"
export * from "./terms-condition.vue?vue&type=script&setup=true&lang=ts"

import "./terms-condition.vue?vue&type=style&index=0&id=d3817256&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3817256"]])

export default __exports__